import React from "react";
import Image from "../../../elements/Image";
import { useBanner } from "../../../../providers/BannerProviders";

const HomeHowItWorks = () => {
  const { data } = useBanner();
  const homeHowItWorks = data?.data?.find((item) => item?.slug === "turn-photos-into-personalized-coloring-books-1747829520846");
  const HwiHeading = homeHowItWorks?.secondSubSectionHead;
  const howitworksdata = homeHowItWorks?.secondSubSection || [];

  return (
    <>
      <section className="relative py-16 overflow-hidden bg-md-pink-light-2">
        <div className="relative w-full px-4 sm:px-0 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto">
          <div className="space-y-8 sm:space-y-16">
            <div className="space-y-6 text-center">
              <h2
                className="text-4xl xl:text-5xl 3xl:text-6xl font-semibold tracking-tight text-md-dark"
                dangerouslySetInnerHTML={{
                  __html: HwiHeading?.heading || "How it works",
                }}
              />
              <div
                className="text-lg lg:text-xl xl:text-2xl 3xl:text-3xl tracking-wide text-neutral-500 max-w-xl lg:max-w-4xl 3xl:max-w-5xl mx-auto leading-snug"
                dangerouslySetInnerHTML={{
                  __html: HwiHeading?.description || " Transform your cherished memories into a fun and creative activity in just a few easy steps. It's simple, quick, and the results are magical!",
                }}
              />
            </div>
            {howitworksdata?.length > 0 && (
              <div className="grid sm:grid-cols-3 gap-4 xl:gap-8 3xl:gap-10">
                {howitworksdata?.map((item, index) => (
                  <div key={index} className="relative py-12 sm:py-6 lg:py-12 px-8 sm:px-4 lg:px-8 rounded-2xl bg-white border-2 border-md-pink-light-3 flex flex-col items-center space-y-4 lg:space-y-8">
                    <div className="w-20 sm:w-16 lg:w-20 aspect-square p-4 sm:p-3 lg:p-4 bg-md-pink-light-1 flex rounded-full">
                      <Image src={item?.image} alt={""} width={"100%"} height={"100%"} effect={"blur"} classes={"object-contain"} />
                    </div>
                    <div className="text-center space-y-4 lg:space-y-6 max-w-xs 3xl:max-w-sm mx-auto">
                      <h3 className="font-semibold text-xl sm:text-base lg:text-xl xl:text-2xl 3xl:text-3xl text-md-dark">{parseInt(index + 1) + ". " + item?.heading}</h3>
                      <div
                        className="text-lg sm:text-sm lg:text-base xl:text-xl 3xl:text-2xl text-neutral-500"
                        dangerouslySetInnerHTML={{
                          __html: item?.description || "",
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeHowItWorks;
